export { SignaturePadPaper } from './SignaturePadPaper';

export const signaturePadHeight = 315;